import { Router } from "../router";
import { AgentStore } from "@/app_store/agent_store";
import { router as heartbeatRouter } from "./heartbeat";

export const router = new Router<AgentStore>();
router.include(heartbeatRouter);
